// "Dark cockpit" palette: only amber + red carry meaning. Everything else is
// grayscale, separated by value. Cells that need action are loud; resolved /
// future cells recede. Keep these as hex literals — they're feature-scoped.
// Promote into a Chakra token namespace if/when this palette spreads outside
// the matrix.

export const COCKPIT = {
  // Overdue — soft red fill behind the cell + a darker mark for the box border
  // and the small tooltip text.
  red: {
    fill: "#FCEBEB",
    mark: "#A32D2D",
  },

  // Due soon — amber border on the actionable box, slightly darker text for
  // tooltip phrasing.
  amber: {
    border: "#BA7517",
    text: "#854F0B",
  },

  // Open (live, undone, on time) — the darkest grayscale glyph since this is
  // the work the eye should find next after exceptions.
  open: {
    border: "#5F5E5A",
  },

  // Resolved / future glyphs — done, skipped, NA, locked-future. Recede into
  // the background but stay legible.
  resolved: "#B4B2A9",
} as const;
